(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["store-review-fixes"] && !Shopify.designMode) return;
  try {
    (() => {
    const selector = '.main-header--nav-links details[data-nav-details]';
    const syncMenu = (details) => {
      const item = details.parentElement;
      const summary = details.querySelector(':scope > summary');
      const menu = item.querySelector(':scope > .dropdown-wrap');
      if (!summary || !menu) return;
      summary.setAttribute('role', 'button');
      summary.setAttribute('aria-controls', menu.id);
      summary.setAttribute('aria-expanded', String(details.open));
      item.setAttribute('aria-expanded', String(details.open));
      menu.setAttribute('aria-hidden', String(!details.open));
    };
    const initialise = () => document.querySelectorAll(selector).forEach(syncMenu);
    document.addEventListener('toggle', (event) => {
      if (event.target.matches?.(selector)) syncMenu(event.target);
    }, true);
    document.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape') return;
      const menu = event.target.closest('.main-header--nav-links');
      if (!menu) return;
      const openMenus = [...menu.querySelectorAll('details[open]')];
      const current = openMenus.reverse().find((details) => details.parentElement.contains(event.target));
      if (!current) return;
      event.preventDefault();
      current.open = false;
      syncMenu(current);
      current.querySelector(':scope > summary').focus();
    });
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initialise, { once: true });
    } else {
      initialise();
    }
    document.addEventListener('shopify:section:load', initialise);
  })();
  } catch(e) { console.error(e); }
})();

})();
